<template src="./List.html"></template>

<script>
import VueResizable from 'vue-resizable';
import Pagination from "@/components/components/pagination";
import {createNamespacedHelpers} from 'vuex';
import {config} from "@/config";

const {mapGetters, mapActions} = createNamespacedHelpers('order/list');

export default {
  name: "OrderList",
  components: {
    VueResizable,
    Pagination
  },
  data() {
    return {
      cellDetailText: '',
      cellDetailLink: '',
      cellDetailLinkList: [],
      windowHeight: false,
      mainTableTop: 140,
      mainErrorTableTop: false,
      hostApi: config.apiUrl,
      tabScrollStyle: {
        width: null,
        height: null,
        float: 'none'
      },
      resizeWidth: '1920px',
      idSign: false,
      idToSign: false,
      options: [
        {value: '=', text: '='},
        {value: '>', text: '>'},
        {value: '<', text: '<'}
      ],
      filterData: {},
      rangeFilterData: {
        'fromSign': {},
        'fromVal': {},
        'toSign': {},
        'toVal': {},
      },
      idFilter: null,
      idToFilter: null,
      showOverlay: false,
    }
  },
  methods: {
    ...mapActions(['GET_ALL']),

    markCell: function (event) {
      // toggle focus of cell
      console.log(event.target);
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      event.target.classList.add('selectedCall');
      this.$nextTick(() => {
        this.windowResize();
      });
    },
    markCellSpan: function (ref) {
      // toggle focus of cell
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      this.$refs[ref].classList.add('selectedCall');
      this.$nextTick(() => {
        this.windowResize();
      });
    },
    showCellContent: function (text) {
      text = text.toString();
      // show detail
      this.cellDetailLink = '';
      this.cellDetailText = '';
      this.cellDetailLinkList = [];
      if (text.indexOf('http') !== -1) {
        this.cellDetailLink = text;
      } else {
        this.cellDetailText = text;
      }
      this.$nextTick(() => {
        this.windowResize();
      });
    },
    showPhotoPdf: function (value) {
      // show detail
      this.cellDetailLink = '';
      this.cellDetailText = '';
      this.cellDetailLinkList = value;
    },
    goToPage: function (page) {
      this.$store.commit('order/list/CURRENT_PAGE', page);
      this.GET_ALL({th: this});
    },
    perPage: function (page) {
      this.$store.commit('order/list/PAGE_SIZE', page);
      this.GET_ALL({th: this});
    },
    widthTab: function () {
      this.tabScrollStyle.width = (window.innerWidth - 190) + 'px';
      this.resizeWidth = (window.innerWidth - 190) + 'px';
    },
    getCommentTitle: function (data) {
      if (data.field.key.indexOf('additional_') != -1) {
        let number = data.field.key.replace('additional_', '');
        return data.item['comment_' + number] != null ? data.item['comment_' + number] : '';
      }

      return '';
    },
    setFilter: function () {
      this.$store.commit('order/list/CURRENT_PAGE', 1)
      this.$store.commit('order/list/FILTER_DATA', this.filterData);
      this.$store.commit('order/list/RANGE_FILTER_DATA', this.rangeFilterData);
      this.GET_ALL({th: this});
    },
    changeSing: function (val) {
      if (val == '' || val == null || val == undefined) {
        return;
      }

      this.setFilter();
    },
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - this.mainTableTop) / 28.5);
      this.$store.commit('order/list/PAGE_SIZE', winHeight);
    },
    sortingChanged: function (ctx) {
      this.$store.commit('order/list/CURRENT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
      this.$store.commit('order/list/CURRENT_SORT', ctx.sortBy);
      this.GET_ALL({th: this});
    },
    windowResize: function () {
      this.windowHeight = window.innerHeight;
      this.$nextTick(() => {
        this.tabScrollStyle.height = (this.windowHeight - this.mainTableTop) + 'px';
      });
    },
  },
  computed: {
    ...mapGetters([
      'GOODS_LIST',
      'CURRENT_PAGE',
      'AMOUNT_PAGE',
      'COUNT_ROW',
      'FIELDS_LIST',
      'PAGE_SIZE',
    ]),
    getFieldsList: function () {
      var fields = [];
      this.FIELDS_LIST.forEach((val) => {
        fields.push({
          key: val.key,
          label: val.label,
          sortable: true
        });
      });
      return fields;
    }
  },
  mounted: function () {
    if (this.$store.getters.getAllowSection.indexOf('order') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    this.widthTab();
    this.initPageSize();
    this.GET_ALL({th: this});
    this.windowResize();
  },
  created() {
    window.addEventListener("resize", this.widthTab);
    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
}
</script>

<style scoped>
.tab-width {
  width: 4000px;
}

.tab-scroll {
  overflow-x: scroll;
  width: 1920px;
}

.t-cell {
  overflow: hidden;
  display: block;
  height: 23px;
  font-size: 0.9rem;
  padding: 0 0.2rem;
}

.resizable-component {
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #e9ecef;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
}

.cell-detail.resizable-content {
  background-color: #e9ecef;
}

.cell-cursor {
  cursor: cell;
  padding: 1px;
}

.cell-cursor:hover {
  border: solid 1px grey;
  padding: 0;
}

.cell-cursor.selectedCall {
  border: solid 2px #007bff;
  padding: 0;
}

.name-coll-selected {
  font-size: 0.8rem;
  display: block;
}

.common-head-cell {
  height: 4rem;
  display: block;
  text-align: center;
  padding: 0 0.2rem;
}

.index-call {
  vertical-align: middle;
}

.t-head-cell.number-head {
  display: block;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.resizable-content {
  height: 100%;
  width: 100%;
  background-color: aqua;
}

.b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
  margin-bottom: 0;
}

.apply-cancel-import {
  width: 150px;
}

.pagination-box {
  overflow: auto;
}

.table {
  margin-bottom: 0;
}

.sign-val {
  width: 130px;
}

.input-filter {
  min-width: 150px;
}
</style>

<style>
.table th, .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}
</style>